import { Site, Role } from "webportalclient";

export interface Option {
    label: string;
    value: string;
}

export const MapToSiteOptions = (results: Site[]): Option[] => results.map(v => ({ label: `(${v.study.name}) ${v.number}`, value: v.id }));
export const MapToRoleOptions = (results: Role[]): Option[] => results.map(v => ({ label: `(${v.study?.name ?? "All Studies"}) ${v.name}`, value: v.id }));
